import type { FC, HTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

export interface AvatarProps extends HTMLAttributes<HTMLDivElement> {
  bgColor?: string;
}

/**
 * A component that displays a simple circle with the text inside.
 */
export const Avatar: FC<AvatarProps> = ({ className, bgColor, children, style, ...props }) => {
  return (
    <div
      {...props}
      className={twMerge(
        "flex size-9 items-center justify-center rounded-full text-base font-semibold shadow-md",
        className,
      )}
      style={bgColor ? { ...style, backgroundColor: bgColor } : style}
    >
      {children}
    </div>
  );
};
